module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Medium.e68e938.otf";